import React from 'react';

import { Actions, Action, SaveAltIcon } from '@gogame/components';

import { usePlanStateField } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanState';
import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { BUDGET } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

export default () => {
  const { onChange } = usePlanStateField(BUDGET);

  const { budgetRest } = useViewStateByResolveName();

  const handleRestBudget = React.useCallback(
    (e) => {
      onChange(e, budgetRest);
    },
    [budgetRest]
  );

  return (
    <Actions limit={1}>
      <Action
        label={'Fill rest of the budget here'}
        icon={<SaveAltIcon />}
        onClick={handleRestBudget}
      />
    </Actions>
  );
};
